import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import CardPresetConfigDrawer from "../../components/admin/CardPresetConfigDrawer";
import CardSettingsTable from "../../components/admin/cards/CardSettingsTable";
import DeleteCardSettingsModal from "../../components/admin/DeleteCardSettingsModal";
import { PageContainer } from "@outpave/ds";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";
import { useDrawerRecord } from "hooks/useDrawerRecord";

const CardSettings: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useNavBreadcrumbs(t("Card Settings"));

  const [openDeleteCardSettingsModal, setOpenDeleteCardSettingsModal] =
    useState<boolean>(false);

  const [refreshPresets, setRefreshPresets] = useState(0);

  const handleRefreshPresets = () => {
    setRefreshPresets((prev) => prev + 1);
  };

  // The preset being deleted.
  const [selectedId, setSelectedId] = useState<string>("");

  // Holds the preset through the slide-out, which would otherwise turn "Edit Preset" into "Create Preset".
  const presetDrawer = useDrawerRecord<{ presetId?: string }>();

  const handleCloseDrawer = (isReloadData = false) => {
    if (isReloadData) {
      handleRefreshPresets();
    }
    presetDrawer.close();
  };

  const handleCloseDeleteModal = (isReloadData = false) => {
    if (isReloadData) {
      handleRefreshPresets();
    }
    setSelectedId("");
    setOpenDeleteCardSettingsModal(false);
  };

  const handleOpenCardPresetConfigDrawer = () => {
    presetDrawer.show({});
  };

  const handleDeleteButton = (id: string) => {
    setSelectedId(id);
    setOpenDeleteCardSettingsModal(true);
  };

  const handleEditButton = (id: string) => {
    presetDrawer.show({ presetId: id });
  };

  return (
    <PageContainer
      title={t("Card Settings")}
      breadcrumbs={breadcrumbs}
      primaryAction={
        <Button onClick={handleOpenCardPresetConfigDrawer}>
          {t("Add configuration")}
        </Button>
      }
    >
      <CardSettingsTable
        handleEditButton={handleEditButton}
        handleDeleteButton={handleDeleteButton}
        refreshPresets={refreshPresets}
      />

      {presetDrawer.record && (
        <CardPresetConfigDrawer
          selectedId={presetDrawer.record.presetId}
          open={presetDrawer.open}
          handleCloseDrawer={handleCloseDrawer}
          onAfterClose={presetDrawer.afterClose}
        />
      )}
      <DeleteCardSettingsModal
        open={openDeleteCardSettingsModal}
        handleCloseModal={handleCloseDeleteModal}
        selectedId={selectedId}
      />
    </PageContainer>
  );
};

export default CardSettings;
